/**
 * Measured silhouette of a loaded body GLTF. Stored on
 * `bodyRoot.userData.bodyBounds` by GLTFBody after the visible-skinned-mesh
 * sweep, then read by MeshAttachment to drive proportional placement of
 * procedural attachments (shoulder caps, belt, sash) — no per-rig hardcoded
 * offsets.
 *
 * Lives in its own module so MeshAttachment can read the type without
 * importing from PlayerCharacter (which itself imports MeshAttachment).
 */
export interface BodyBounds {
  feetY: number;
  headTopY: number;
  height: number;
  centerX: number;
  centerZ: number;
  halfWidth: number;
  halfDepth: number;
}

/** Sensible chibi defaults used when bbox isn't yet available (e.g. first
 *  frame before GLTFBody.useEffect ran). Sized for the cyber-knight rig. */
export const FALLBACK_BODY_BOUNDS: BodyBounds = {
  feetY: 0,
  headTopY: 1.4,
  height: 1.4,
  centerX: 0,
  centerZ: 0,
  halfWidth: 0.25,
  halfDepth: 0.18,
};
